import { data } from 'jquery';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../components/doctors/partials/Header';
import TopLeftMenu from '../../components/doctors/partials/topLeftMenu';
import {
  deleteRequest,
  getRequest,
  postRequest,
  patchRequest,
} from '../../utils/axiosRequests';
import {
  capitalizeFirstLetter,
  deleteConfirmation,
  getPatientIdForDoctor,
} from '../../utils/helpers';
import { initSocket, disconnectSocket } from '../../utils/socket';

function Appointments() {
  const currentDate = moment().format('YYYY-MM-DD');
  const dateEnd = moment().add(6, 'months').format('YYYY-MM-DD');
  const [appointments, setAppointments] = useState([]);
  const [itemsCount, setItemsCount] = useState(0);
  const [totalItem, setTotalItem] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const userInfo = useSelector((state) => state.authReducer.data);
  const activeDoctor = useSelector(
    (state) => state.doctorsOfAssistantReducer.activeDoctor,
  );
  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );
  const [q, setQ] = useState('');
  const [patientId, setPatientId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [patientType, setPatientType] = useState('');
  const [appointmentType, setAppointmentType] = useState('');
  const [appointmentStatus, setAppointmentStatus] = useState('new');
  const [scheduleType, setScheduleType] = useState('today');
  const [startDate, setStartDate] = useState(currentDate);
  const [endDate, setEndDate] = useState(dateEnd);
  const [clearFilter, setClearFilter] = useState(true);
  const [showPatientProfile, setShowPatientProfile] = useState(false);
  const handlePatientProfleClose = () => setShowPatientProfile(false);
  const [serialSort, setSerialSort] = useState(false);
  const [firstTimeFlag, setFirstTimeFlag] = useState(true);
  const navigate = useNavigate();
  const [showMoreFilter, setShowMoreFilter] = useState(false);
  const location = useLocation();
  const appointStatus = location?.state?.status ? location?.state?.status : '';
  const [tdToggles, setTdToggles] = useState([]);

  const getAppointments = async () => {
    console.log('activeDoctor: ', activeDoctor, userInfo);
    let orgObj =
      userInfo.userType === 'assistant'
        ? userInfo?.organizationIds[0]
        : activeOrganization;
    let url = `appointments?organizationId=${orgObj.id}&page=${currentPage}`;
    console.log(url, 'urlurl');
    if (q) {
      url += '&q=' + q;
    }
    if (patientType) {
      url += '&patientType=' + patientType;
    }
    if (appointmentType) {
      url += '&appointmentType=' + appointmentType;
    }
    if (appointmentStatus !== 'all') {
      url += appointmentStatus ? '&appointmentStatus=' + appointmentStatus : '';
    }
    if (scheduleType === 'today') {
      url += '&startDate=' + startDate;
      url += '&endDate=' + startDate;
    } else if (scheduleType === 'all') {
      url += '&startDate=' + startDate;
      url += '&endDate=' + endDate;
    }

    if (userInfo.userType === 'assistant') {
      url += '&doctorId=' + activeDoctor.id;
    } else {
      url += '&doctorId=' + userInfo.id;
    }

    // url +=
    //   appointmentStatus !== 'all'
    //     ? appointmentStatus
    //       ? '&appointmentStatus=' + appointmentStatus
    //       : '&appointmentStatus=' + appointStatus
    //     : '';

    await getRequest(url)
      .then((res) => {
        if (currentPage === 1) {
          setAppointments([...res.appointments]);
          setItemsCount(res.total);
          setTotalItem(res.total);
          setFirstTimeFlag(true);
        } else {
          if (appointments.length < itemsCount) {
            setAppointments([...appointments, ...res.appointments]);
            setItemsCount(res.total);
          }
        }
      })
      .catch((e) => {
        console.log(e.message);
      });
  };

  // let socket = initSocket();
  // useEffect(() => {
  //   if (userInfo.userType === 'doctor') {
  //     socket = initSocket();
  //     socket.emit('setUsername', userInfo.id);
  //   }
  //   // return () => disconnectSocket(); // cleanup on unmount
  // }, []);

  const getAppointmentsToday = async () => {
    let orgObj =
      userInfo.userType === 'assistant'
        ? userInfo?.organizationIds[0]
        : activeOrganization;
    let url = `appointments?organizationId=${orgObj.id}&doctorId=${userInfo.id}&appointmentStatus=new&startDate=${currentDate}&endDate=${currentDate}`;

    return await getRequest(url)
      .then((res) => res.appointments)
      .catch((e) => {
        console.log(e.message);
      });
  };

  const updateAppointmentStatus = async (id) => {
    await patchRequest(`appointments/${id}`, {
      status: 'consulting',
      doctorId:
        userInfo.userType === 'assistant' ? activeDoctor.id : userInfo.id,
    });
  };

  const getPatientId = (orgSeqs) => {
    const orgSeq = orgSeqs.find((item) => item.orgId === activeOrganization.id);
    if (orgSeq) return orgSeq.seq;
    else return '';
  };

  const getAppointmentStatus = (status) => {
    if (status === 'new')
      return (
        <span style={{ color: 'green', fontWeight: 'bold' }}>Pending</span>
      );
    else if (status === 'completed')
      return (
        <span
          className="appointment-status"
          style={{
            backgroundColor: '#36b9cc',
          }}
        >
          Completed
        </span>
      );
    else return capitalizeFirstLetter(status);
  };

  const getAppointmentDateTime = (date) => {
    const dateParts = date.split(' ');
    if (dateParts.length > 4) {
      return (
        <>
          <span
            style={{
              // display: 'block',
              lineHeight: '8px',
              paddingBottom: '4px',
            }}
          >
            {dateParts[0] + ' ' + dateParts[1] + ', ' + dateParts[2]},
            <span
              style={{
                fontSize: '12px',
                fontStyle: 'italic',
                paddingLeft: '5px',
              }}
            >
              {dateParts[3] + dateParts[4]}
            </span>
          </span>
        </>
      );
    } else {
      return data;
    }
  };

  const getAppointmentPayment = (appointment) => {
    if (
      appointment?.paymentDetails &&
      appointment?.paymentDetails?.paymentStatus === 'completed'
    ) {
      return (
        <span className="payment-success">
          {/* <i className="fas fa-check-circle"></i> Paid */}
          {/* <i className="fas fa-money-bill"></i> Paid */}
          Paid
        </span>
      );
    } else if (
      appointment?.paymentDetails &&
      appointment?.paymentDetails?.paymentStatus === 'pending'
    ) {
      return (
        <span className="payment-pending">
          <i className="fa fa-exclamation-circle"></i> Pending
        </span>
      );
    } else if (
      appointment?.paymentDetails &&
      appointment?.paymentDetails?.paymentStatus === 'unpaid'
    ) {
      return (
        <span className="payment-unpaid">
          {/* <i className="fas fa-times-circle"></i> Unpaid */}
          {/* <i className="fas fa-money-bill"></i> Unpaid */}
          Unpaid
        </span>
      );
    } else if (
      appointment?.paymentDetails &&
      appointment?.paymentDetails?.paymentStatus === 'cancelled'
    ) {
      return (
        <span className="payment-cancelled">
          <i className="fa fa-minus-circle"></i> Cancelled
        </span>
      );
    } else {
      return <span>N/A</span>;
    }
  };

  const getVisitType = (appointment) => {
    const type = appointment?.visitType;
    let color, label;

    switch (type) {
      case 'followup':
        color = '#4e73df';
        label = 'Follow up';
        break;
      case 'report':
        color = '#e74c3c ';
        label = 'Report';
        break;
      default:
        color = '#008000';
        label = 'New';
    }

    return <span style={{ color, fontWeight: 'bold' }}>{label}</span>;
  };

  useEffect(() => {
    if (firstTimeFlag) {
      getAppointments();
    }
  }, [currentPage, clearFilter, firstTimeFlag]);

  const getLoadMore = () => {
    setCurrentPage(currentPage + 1);
    getAppointments();
  };

  const handleFilter = (e) => {
    e.preventDefault();
    setAppointments([]);
    setItemsCount(0);
    setClearFilter(false);
    setFirstTimeFlag(false);
    setCurrentPage(1);
    getAppointments();
  };

  const handleClear = () => {
    setQ('');
    setPatientId('');
    setPhoneNumber('');
    setPatientType('');
    setAppointmentType('');
    setAppointmentStatus('');
    setStartDate(currentDate);
    setEndDate(currentDate);
    setClearFilter(true);
    setCurrentPage(1);
  };

  useEffect(() => {
    getAppointments();
  }, []);

  useEffect(() => {
    getAppointments();
  }, [activeDoctor, scheduleType]);

  useEffect(() => {
    let sortedAppointments;
    if (serialSort) {
      sortedAppointments = appointments.sort(
        (a, b) => a.serialNumber - b.serialNumber,
      );
    } else {
      sortedAppointments = appointments.sort(
        (a, b) => b.serialNumber - a.serialNumber,
      );
    }
    setAppointments([...sortedAppointments]);
  }, [serialSort]);

  let count = 1;

  const handleRowClick = async (appointment) => {
    if (userInfo.userType === 'doctor') {
      await updateAppointmentStatus(appointment.id);

      // if (socket) {
      // socket.emit('privateMessage', {
      //   toUsername: userInfo.id,
      //   appointments: allWaitingAppointments,
      // });
      // }
    }
    navigate('/patient-history', {
      state: {
        appointment,
        patientData: { ...appointment.patientId },
      },
    });
  };

  const editPrescription = (data, type) => {
    if (type === 'editFromList') {
      navigate('/prescription', {
        state: {
          appointmentInfo: data,
          history: type,
          dob: data?.patientId?.dob,
        },
      });
    } else if (type === 'onlyAppointment') {
      navigate('/prescription', {
        state: {
          appointment: data,
          history: type,
          dob: data?.patientId?.dob,
        },
      });
    }
  };

  const editAppointment = async (data) => {
    // if (userInfo.userType === 'doctor') {
    //   await updateAppointmentStatus(data.id);
    // }
    navigate('/edit-appointment', {
      state: {
        appointmentInfo: data,
      },
    });
  };

  const deleteAppointment = (id) => {
    deleteRequest(`appointments/${id}`)
      .then((data) => {
        setAppointments(appointments?.filter((appt) => appt.id !== id));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const toggleTRItem = (key) => {
  //   setTdToggles((prev) => ({
  //     ...prev,
  //     [key]: !prev[key],
  //   }));
  // };
  const toggleTRItem = (key) => {
    console.log('type check: ', tdToggles);
    if (tdToggles.includes(key)) {
      const filteredItems = tdToggles.filter((item) => item !== key);
      setTdToggles(filteredItems);
    } else {
      setTdToggles([...tdToggles, key]);
    }
    console.log('worked');
  };

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-md-12 sticky-header shadow header-sticky-second">
            <TopLeftMenu />
          </div>
        </div>
        <Row className="rx-body">
          <div className="col-xl-12 col-md-12 col-lg-12">
            <div className="card shadow mb-4">
              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <Form className="container-fluid">
                  <Row>
                    <Col xs={12} sm={12} md={2} lg={2}>
                      <h6 className="m-0 font-weight-bold text-primary">
                        Appointments
                      </h6>
                    </Col>
                    <Col xs={12} sm={12} md={7} lg={7}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          className="search-icon"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z"
                            stroke="currentColor"
                            fill="none"
                            fillRule="evenodd"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        <Form.Control
                          type="text"
                          className="form-control"
                          placeholder="Search By Name, Patient ID, Phone Number"
                          style={{
                            paddingLeft: '2.1rem',
                            borderRadius: '2.1rem',
                          }}
                          value={q}
                          onChange={(e) => setQ(e.target.value)}
                        />
                        <i
                          className="fa fa-bars hide-show-bar pt-2"
                          onClick={() => setShowMoreFilter(!showMoreFilter)}
                        ></i>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3} className="mt-2-mobile">
                      <div className="justify-content-space-between-wrap">
                        <div
                          className="justify-content-space-between-wrap"
                          style={{ maxWidth: '12rem' }}
                        >
                          <Button
                            variant="outline-success"
                            type="submit"
                            className="btn-sm mb-1 mr-2"
                            onClick={handleFilter}
                          >
                            <i className="fa fa-filter"></i> Filter
                          </Button>
                          <Button
                            variant="outline-danger"
                            className="btn-sm mb-1"
                            type="button"
                            onClick={handleClear}
                          >
                            <i className="fa fa-redo" title="Show More"></i>{' '}
                            Clear
                          </Button>
                        </div>
                        <Link
                          style={{ marginRight: '0px' }}
                          className="appointment_create_mobile"
                          to={'/new-appointment'}
                        >
                          <Button
                            variant="success"
                            type="submit"
                            className="btn-sm"
                          >
                            <i className="fa fa-plus-circle"></i> Create New
                          </Button>
                        </Link>
                      </div>
                    </Col>
                  </Row>
                  {/* {showMoreFilter && ( */}
                  {showMoreFilter && (
                    <div className="appointment-filter">
                      <div>
                        <Form.Select
                          className="form-control form-control-sm appointment_button"
                          onChange={(e) => setPatientType(e.target.value)}
                          value={patientType}
                        >
                          <option value="">Patient Type</option>
                          <option value="all">All</option>
                          <option value="new">New</option>
                          <option value="old">Old</option>
                        </Form.Select>
                      </div>
                      {/* <div>
                        <Form.Select
                          className="form-control form-control-sm appointment_button"
                          value={appointmentType}
                          onChange={(e) => setAppointmentType(e.target.value)}
                        >
                          <option value="">Appointment Type</option>
                          <option value="inPerson">Physical</option>
                          <option value="remote">Online</option>
                        </Form.Select>
                      </div> */}
                      {/* <div>
                        <Form.Select
                          className="form-control form-control-sm appointment_button"
                          value={appointmentStatus}
                          onChange={(e) => setAppointmentStatus(e.target.value)}
                        >
                          <option value="all">Appointment Status</option>
                          <option value="new">New</option>
                          <option value="pending">Pending</option>
                          <option value="completed">Completed</option>
                          <option value="canceled">Canceled</option>
                          <option value="approved">Approved</option>
                        </Form.Select>
                      </div> */}
                      <div>
                        <Form.Select
                          className="form-control form-control-sm appointment_button"
                          value={scheduleType}
                          onChange={(e) => setScheduleType(e.target.value)}
                        >
                          <option value="all">All Appointments</option>
                          <option value="today">Today Appointments</option>
                        </Form.Select>
                      </div>
                      {scheduleType === 'all' && (
                        <Fragment>
                          <div className="d-inline-flex">
                            <Form.Control
                              type="date"
                              className="form-control-sm appointment_button_date"
                              data-date-format="DD MMMM YYYY"
                              defaultValue={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>
                          <div
                            className="d-inline-flex"
                            style={{ marginTop: '13px' }}
                          >
                            To
                          </div>
                          <div className="d-inline-flex">
                            <Form.Control
                              type="date"
                              className="form-control-sm appointment_button_date"
                              // style={{ width: '9rem' }}
                              name="endDate"
                              placeholder="To"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>
                        </Fragment>
                      )}
                    </div>
                  )}
                  {/* )} */}
                </Form>
              </div>
              <div className="card-body appointment-card-body">
                <div style={{ margin: '15px' }}>
                  <Table
                    hover
                    id="appointmentTable"
                    style={{
                      marginTop: '1rem',
                      borderCollapse: 'collapse',
                      marginBottom: '0rem',
                    }}
                  >
                    {/* <thead>
                      <tr>
                        <th style={{ width: '3%' }}>No</th>
                        <th
                          className=""
                          style={{ width: '7%', cursor: 'pointer' }}
                          onClick={() => {
                            setSerialSort(!serialSort);
                          }}
                        >
                          Serial{' '}
                          {!serialSort && <i className="fa fa-arrow-up"></i>}{' '}
                          {serialSort && <i className="fa fa-arrow-down"></i>}
                        </th>
                        <th style={{ width: '16%' }}>Name</th>
                        <th style={{ width: '10%' }}>Patient ID</th>
                        <th style={{ width: '10%' }}>Mobile Number</th>
                        <th style={{ width: '10%' }}>Patient Type</th>
                        <th style={{ width: '17%' }}>Appointment Date</th>
                        {/* <th style={{ width: '8%' }}>Appointment Status</th> */}
                    {/*<th style={{ width: '10%' }}>Payment Status</th>
                        <th className="" style={{ width: '18%' }}>
                          Action
                        </th>
                      </tr>
                    </thead> */}
                  </Table>
                  <div
                    style={{
                      height: '615px',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                    }}
                  >
                    <Table>
                      <tbody>
                        {
                          (count =
                            1 &&
                            appointments.map((appointment, index) => (
                              <>
                                <tr
                                  key={appointment.id + 'mobile'}
                                  className={`td-on-desktop  ${
                                    tdToggles.includes(appointment.id)
                                      ? 'hide'
                                      : ''
                                  }`}
                                  style={{
                                    borderTop: '0px',
                                    cursor: 'pointer',
                                    color: 'black',
                                  }}
                                  onClick={() => handleRowClick(appointment)}
                                >
                                  <td
                                    colspan="12"
                                    className="justify-content-space-between-wrap"
                                  >
                                    <span
                                      className="top-space-cell"
                                      style={{ flex: 0.5 }}
                                    >
                                      #{count}
                                    </span>
                                    <span
                                      className="top-space-cell"
                                      style={{ flex: 0.5 }}
                                    >
                                      SL: {appointment?.serialNumber}
                                    </span>
                                    <span
                                      className="top-space-cell"
                                      style={{ flex: 1.5 }}
                                    >
                                      {appointment?.patientId?.name || ''}
                                    </span>
                                    <span
                                      className="top-space-cell"
                                      style={{ flex: 1 }}
                                    >
                                      {appointment?.patientId?.phoneNumber ||
                                        ''}
                                    </span>
                                    <div
                                      className="top-space-cell"
                                      style={{ flex: 1.6, textAlign: 'right' }}
                                    >
                                      {/* <i
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          toggleTRItem(appointment.id);
                                        }}
                                        className="fas fa-eye td-details-hide"
                                        style={{
                                          width: '2rem',
                                          color: '#0d6efd',
                                        }}
                                      ></i> */}
                                      {appointment?.status === 'completed' &&
                                        userInfo?.userType === 'doctor' && (
                                          // <button
                                          //   class="edit-btn sm"
                                          //   aria-label="Edit item small"
                                          //   onClick={(e) => {
                                          //     e.stopPropagation();
                                          //     editAppointment(
                                          //       appointment,
                                          //       'editFromList',
                                          //     );
                                          //   }}
                                          // >
                                          //   <i
                                          //     class="fa fa-edit mr-2"
                                          //     aria-hidden="true"
                                          //   ></i>
                                          //   Edit
                                          // </button>
                                          <button
                                            class="edit-btn sm"
                                            aria-label="Edit item small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              editAppointment(appointment);
                                            }}
                                          >
                                            <i
                                              class="fa fa-edit"
                                              aria-hidden="true"
                                            ></i>
                                            Edit
                                          </button>
                                        )}
                                      {appointment.status !== 'completed' &&
                                        userInfo?.userType === 'doctor' && (
                                          // <i
                                          //   style={{
                                          //     cursor: 'pointer',
                                          //     color: '#1cc88a',
                                          //   }}
                                          //   className="fas fa-file-medical new-edit-icon new-app mr-2"
                                          //   onClick={(e) => {
                                          //     e.stopPropagation();
                                          //     editPrescription(
                                          //       appointment,
                                          //       'onlyAppointment',
                                          //     );
                                          //   }}
                                          // ></i>
                                          <button
                                            class="edit-btn-mobile sm"
                                            aria-label="Edit item small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              editAppointment(appointment);
                                            }}
                                          >
                                            <i
                                              class="fa fa-edit"
                                              aria-hidden="true"
                                            ></i>
                                            Edit
                                          </button>
                                        )}

                                      {appointment.status === 'new' &&
                                        userInfo?.userType === 'assistant' && (
                                          // <span
                                          //   className="new-app"
                                          //   style={{
                                          //     width: '2rem',
                                          //     display: 'inline-block',
                                          //     color: 'green',
                                          //   }}
                                          //   onClick={(e) => {
                                          //     e.stopPropagation();
                                          //     editAppointment(appointment);
                                          //   }}
                                          // >
                                          //   <i className="fas fa-edit"></i>
                                          // </span>
                                          <button
                                            class="edit-btn-mobile sm"
                                            aria-label="Edit item small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              editAppointment(appointment);
                                            }}
                                          >
                                            <i
                                              class="fa fa-edit"
                                              aria-hidden="true"
                                            ></i>
                                            Edit
                                          </button>
                                        )}

                                      {appointment.status === 'new' &&
                                        (userInfo?.userType === 'doctor' ||
                                          userInfo?.userType ===
                                            'assistant') && (
                                          // <i
                                          //   onClick={(e) => {
                                          //     e.stopPropagation();
                                          //     deleteConfirmation(
                                          //       deleteAppointment,
                                          //       appointment.id,
                                          //     );
                                          //   }}
                                          //   className="fas fa-trash"
                                          //   style={{ width: '1rem' }}
                                          // ></i>
                                          <button
                                            className="delete-btn-mobile sm ml-1"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteConfirmation(
                                                deleteAppointment,
                                                appointment.id,
                                              );
                                            }}
                                          >
                                            <i
                                              className="fa fa-trash-alt"
                                              aria-hidden="true"
                                            ></i>
                                            <span>Delete</span>
                                          </button>
                                        )}
                                    </div>
                                  </td>
                                </tr>
                                <tr
                                  key={appointment.id + 'desktop'}
                                  style={{
                                    borderTop: '0px',
                                    cursor: 'pointer',
                                    color: 'black',
                                  }}
                                  onClick={() => handleRowClick(appointment)}
                                  // className="td-on-mobile"
                                  className={`${
                                    tdToggles.includes(appointment.id)
                                      ? ''
                                      : 'td-on-mobile'
                                  }`}
                                >
                                  <td
                                    className={`mobile-td sn`}
                                    data-cell="Count"
                                    style={{ marginTop: '.4rem' }}
                                    width="3%"
                                  >
                                    #{count++}
                                  </td>
                                  <td
                                    className={`mobile-td serial`}
                                    data-cell="Serial"
                                    width="5%"
                                  >
                                    SL: {appointment?.serialNumber}
                                  </td>
                                  <td
                                    style={{
                                      cursor: 'pointer',
                                      fontWeight: 'bold',
                                    }}
                                    className={`mobile-td name`}
                                    data-cell="Name"
                                    width="12%"
                                  >
                                    {appointment?.patientId?.name || ''}
                                  </td>
                                  <td
                                    className={`mobile-td patient-id`}
                                    data-cell="Patient Id"
                                    width="7%"
                                  >
                                    ID:{' '}
                                    {getPatientIdForDoctor(
                                      appointment?.patientId
                                        ?.patientIdForDoctor,
                                      userInfo,
                                    )}
                                  </td>
                                  <td
                                    className={`mobile-td mobile-no`}
                                    data-cell="Mobile No"
                                    width="7%"
                                  >
                                    <i
                                      className="fa fa-phone"
                                      style={{
                                        rotate: '105deg',
                                        color: '#237f91',
                                      }}
                                    />{' '}
                                    {appointment?.patientId?.phoneNumber || ''}
                                  </td>
                                  <td
                                    className={`mobile-td patient-type`}
                                    data-cell="Patient Type"
                                    width="7%"
                                  >
                                    <span
                                      className={`${
                                        appointment?.patientType === 'new'
                                          ? 'new_patient_tag'
                                          : 'old_patient_tag'
                                      }`}
                                    >
                                      {capitalizeFirstLetter(
                                        appointment?.patientType,
                                      ) || ''}
                                    </span>
                                  </td>
                                  {/* <td
                                    className={`mobile-td type`}
                                    data-cell="Type"
                                    width="8%"
                                  >
                                    {appointment?.appointmentType === 'inPerson'
                                      ? 'Physical'
                                      : 'Online'}
                                  </td>
                                  <td
                                    className={`mobile-td visit-type`}
                                    data-cell="Visit Type"
                                    width="7%"
                                  >
                                    {getVisitType(appointment)}
                                  </td> */}
                                  <td
                                    className={`mobile-td appointment-date`}
                                    data-cell="Appointment Date"
                                    width="10%"
                                  >
                                    <i
                                      class="far fa-calendar-alt"
                                      style={{ color: '#237f91' }}
                                    ></i>{' '}
                                    {getAppointmentDateTime(
                                      moment(appointment?.appointmentDateTime)
                                        .add(6, 'hours')
                                        .format('Do MMM YYYY h:mm a'),
                                    )}
                                  </td>
                                  {/* <td
                                    className={`mobile-td status`}
                                    data-cell="Status"
                                    width="8%"
                                  >
                                    {getAppointmentStatus(appointment?.status)}
                                  </td> */}
                                  <td
                                    className={`mobile-td payment-status`}
                                    data-cell="Payment Status"
                                    width="6%"
                                  >
                                    <i
                                      className="fa fa-money-bill"
                                      style={{ color: '#237f92' }}
                                    />{' '}
                                    {getAppointmentPayment(appointment)}
                                  </td>
                                  <td
                                    data-cell="Action"
                                    className={`mobile-td ${
                                      appointment.status === 'new' &&
                                      userInfo?.userType === 'doctor'
                                        ? ''
                                        : 'action-col'
                                    } action`}
                                    style={{
                                      textAlign: 'left',
                                    }}
                                    width="12%"
                                  >
                                    <div style={{ paddingBottom: '5px' }}>
                                      {/* <i
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          toggleTRItem(appointment.id);
                                        }}
                                        className="fas fa-eye td-details-hide"
                                        style={{
                                          width: '2rem',
                                          display: 'inline-block',
                                          color: '#0d6efd',
                                        }}
                                      ></i> */}
                                      {appointment?.status === 'completed' &&
                                        userInfo?.userType === 'doctor' && (
                                          // <i
                                          //   style={{
                                          //     cursor: 'pointer',
                                          //     color: '#1cc88a',
                                          //   }}
                                          //   className="fas fa-edit new-edit-icon"
                                          //   onClick={(e) => {
                                          //     e.stopPropagation();
                                          //     editPrescription(
                                          //       appointment,
                                          //       'editFromList',
                                          //     );
                                          //   }}
                                          // ></i>
                                          // <button
                                          //   class="edit-btn sm"
                                          //   aria-label="Edit item small"
                                          //   onClick={(e) => {
                                          //     e.stopPropagation();
                                          //     editAppointment(
                                          //       appointment,
                                          //       'editFromList',
                                          //     );
                                          //   }}
                                          // >
                                          //   <i
                                          //     class="fa fa-edit"
                                          //     aria-hidden="true"
                                          //   ></i>
                                          //   Edit
                                          // </button>
                                          <button
                                            class="edit-btn sm"
                                            aria-label="Edit item small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              editAppointment(
                                                appointment,
                                                'editFromList',
                                              );
                                            }}
                                          >
                                            <i
                                              class="fa fa-edit"
                                              aria-hidden="true"
                                            ></i>
                                            Edit
                                          </button>
                                        )}
                                      {/* {appointment.status !== 'completed' &&
                                        userInfo?.userType === 'doctor' && (
                                          <i
                                            style={{
                                              cursor: 'pointer',
                                              color: '#1cc88a',
                                            }}
                                            className="fas fa-file-medical new-edit-icon new-app"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              editPrescription(
                                                appointment,
                                                'onlyAppointment',
                                              );
                                            }}
                                          ></i>
                                        )} */}

                                      {appointment.status === 'new' &&
                                        (userInfo?.userType === 'assistant' ||
                                          userInfo?.userType === 'doctor') && (
                                          // <span
                                          //   className="new-app"
                                          //   onClick={(e) => {
                                          //     e.stopPropagation();
                                          //     editAppointment(appointment);
                                          //   }}
                                          //   style={{
                                          //     width: '2rem',
                                          //     display: 'inline-block',
                                          //     color: 'green',
                                          //   }}
                                          // >
                                          //   <i className="fas fa-edit"></i>
                                          // </span>
                                          <button
                                            class="edit-btn sm"
                                            aria-label="Edit item small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              editAppointment(appointment);
                                            }}
                                          >
                                            <i
                                              class="fa fa-edit"
                                              aria-hidden="true"
                                            ></i>
                                            Edit
                                          </button>
                                        )}

                                      {appointment.status === 'new' &&
                                        (userInfo?.userType === 'doctor' ||
                                          userInfo?.userType ===
                                            'assistant') && (
                                          // <i
                                          //   onClick={(e) => {
                                          //     e.stopPropagation();
                                          //     deleteConfirmation(
                                          //       deleteAppointment,
                                          //       appointment.id,
                                          //     );
                                          //   }}
                                          //   className="fas fa-trash"
                                          //   style={{ width: '1rem' }}
                                          // ></i>
                                          <button
                                            className="delete-btn sm ml-3"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteConfirmation(
                                                deleteAppointment,
                                                appointment.id,
                                              );
                                            }}
                                          >
                                            <i
                                              className="fa fa-trash-alt pr-2"
                                              aria-hidden="true"
                                            ></i>
                                            <span>Delete</span>
                                          </button>
                                        )}
                                    </div>
                                  </td>
                                </tr>
                              </>
                            )))
                        }
                      </tbody>
                    </Table>
                  </div>
                  {totalItem > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>
                        {appointments && appointments?.length < totalItem && (
                          <Button
                            size="sm"
                            onClick={() => setCurrentPage(currentPage + 1)}
                          >
                            Load More
                          </Button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </div>
    </div>
  );
}

export default Appointments;
